import { render, staticRenderFns } from "./ChatSidebar.vue?vue&type=template&id=bf0433b6&scoped=true&"
import script from "./ChatSidebar.vue?vue&type=script&lang=js&"
export * from "./ChatSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ChatSidebar.vue?vue&type=style&index=0&id=bf0433b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0433b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf0433b6')) {
      api.createRecord('bf0433b6', component.options)
    } else {
      api.reload('bf0433b6', component.options)
    }
    module.hot.accept("./ChatSidebar.vue?vue&type=template&id=bf0433b6&scoped=true&", function () {
      api.rerender('bf0433b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sale/delivery-dashboard/components/chat/ChatSidebar.vue"
export default component.exports